"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextColorMenu = void 0;
var react_1 = __importDefault(require("react"));
var slate_react_1 = require("slate-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var ColorPalette_1 = __importDefault(require("Common/ColorPalette/ColorPalette"));
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var StyleServiceV2_1 = require("@CommonFrontendBackend/StyleServiceV2/StyleServiceV2");
var EditorMarks_1 = require("Project/QwilrEditor/Marks/EditorMarks");
var Text_1 = require("ContentTokens/Models/Text");
var ClientColorProvider_1 = require("DreamCoat/ClientColorProvider");
var TextColorMenu = function (_a) {
    var onFocusChange = _a.onFocusChange, onChange = _a.onChange, selectedElementTypes = _a.selectedElementTypes, blockStore = _a.blockStore;
    var editor = (0, slate_react_1.useSlate)();
    var colorProvider = (0, ClientColorProvider_1.useColorProvider)();
    var selectedColor = selectionContainsColorFromText(editor)
        ? getSelectedColorFromTextStyle(editor)
        : getSelectedColorFromBlockStyle(blockStore.blockStyleStore, selectedElementTypes);
    return (react_1.default.createElement(kaleidoscope_1.ToolbarPopover, { className: tokens_1.darkTheme, size: kaleidoscope_1.PopoverSize.Small, padding: "small", button: function (buttonProps) { return react_1.default.createElement(kaleidoscope_1.ToolbarButton, __assign({}, buttonProps, { icon: react_1.default.createElement(icons_1.Fonts, null) })); } },
        react_1.default.createElement("div", { onFocus: function (e) { return onFocusChange(e, "textColorMenu", true); }, onBlur: function (e) { return onFocusChange(e, "textColorMenu", false); }, tabIndex: -1 },
            react_1.default.createElement(ColorPalette_1.default, { type: "content", presetColors: colorProvider.themeColors, onColorChange: function (color) { return onChange((0, GetBlockStyle_1.convertColorToColorObj)(color)); }, selectedColor: selectedColor ? colorProvider.decorateColor(selectedColor) : undefined }))));
};
exports.TextColorMenu = TextColorMenu;
var selectionContainsColorFromText = function (editor) {
    return (0, EditorMarks_1.getCurrentMarks)(editor, { match: "some" }).some(Text_1.isColorMark);
};
var getSelectedColorFromTextStyle = function (editor) {
    var color = (0, EditorMarks_1.getCurrentMarks)(editor).find(Text_1.isColorMark);
    return color ? (0, GetBlockStyle_1.convertColorObjToColor)(color.data.color) : undefined;
};
var getSelectedColorFromBlockStyle = function (blockStyleStore, elementTypes) {
    var color = (0, StyleServiceV2_1.getCombinedColor)(blockStyleStore.model, elementTypes);
    return color
        ? {
            value: color,
            themeIndex: (0, StyleServiceV2_1.getCombinedColorThemeIndex)(blockStyleStore.model, elementTypes),
        }
        : undefined;
};
